import { render, staticRenderFns } from "./StudentApplications.vue?vue&type=template&id=6601b739"
import script from "./StudentApplications.vue?vue&type=script&lang=js"
export * from "./StudentApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports